<template>
  <div class="pc">
    <router-view @downloadByEmail="onDownloadByEmail"></router-view>
    <a-modal
      id="download-email-form-pc"
      :visible="showDownloadForm"
      :mask-closable="false"
      title="文件下载"
      ok-text="提交"
      cancel-text="取消"
      @ok="beforeDownloadFormClose"
      @cancel="onDownloadFormCancel"
    >
      <div class="pc" style="height: 80px; padding: 10px;">
        <div class="email-form">
          <div class="email-label" style="width: 50px;">邮箱：</div>
          <a-input
            v-model="userEmail"
            placeholder="请输入邮箱地址"
            @change="onInputEmail"
          />
        </div>
        <div class="error-message">
          {{ errorEmailMsg }}
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { ck } from "fire-wind-water";
import { validateEmail } from "@/common/utils.js";
export default {
  name: "Pc",
  data() {
    return {
      // 邮箱下载表单
      showDownloadForm: false,
      userEmail: ck.cookie("user_email"),
      errorEmailMsg: "",
      downloadFile: {}
    };
  },
  methods: {
    // 邮箱下载
    onDownloadByEmail({ file }) {
      this.showDownloadForm = true;
      this.downloadFile = file;
      this.userEmail = ck.cookie("user_email");
    },
    beforeDownloadFormClose() {
      // 验证邮箱输入框
      if (!this.userEmail) {
        this.errorEmailMsg = "请填写邮箱";
        return;
      }
      if (validateEmail(this.userEmail)) {
        ck.cookie("user_email", this.userEmail);
        let smarketMember = ck.cookie(
          "smarketMember_" + this.downloadFile.schemaId
        );
        let sess = smarketMember ? smarketMember.session : "";
        // 发送邮箱下载请求
        this.service
          .downloadWithEmail({
            email: this.userEmail,
            fileList: [this.downloadFile.fileId],
            globalUserId: ck.cookie("globalUserId"),
            sess: sess,
            extra: {
              tenantId: this.downloadFile.tenantId,
              instanceId: this.downloadFile.instanceId,
              memberId: 0,
              moduleId: this.downloadFile.moduleId,
              openId: "",
              weChatId: "",
              objInstanceId: "",
              source: "PC",
              url: window.location.href
            }
          })
          .subscribe(data => {
            let msgSend = "文件已发送至邮箱";
            let msgReview = "审核通过后将发送至邮箱";
            let msgError = "提交异常";
            if (data.result != 0) {
              this.$antMessage.warning(msgError);
            } else if (data.content.isReview == 0) {
              this.$antMessage.success(msgSend);
            } else if (data.content.isReview == 1) {
              this.$antModal.info({
                title: "提示",
                okText: "确定",
                content: msgReview
              });
            }
            this.downloadFile = {};
            this.showDownloadForm = false;
          });
      } else {
        // 提示邮箱错误
        this.errorEmailMsg = "邮箱格式错误";
      }
    },
    onDownloadFormCancel() {
      this.showDownloadForm = false;
      this.errorEmailMsg = "";
      this.downloadFile = {};
    },
    onInputEmail() {
      this.errorEmailMsg = "";
    }
  }
};
</script>

<style scoped lang="scss">
.pc {
  .email-form {
    display: flex;
    align-items: center;
  }
  .error-message {
    padding-left: 50px;
    color: #f5222d;
  }
}
</style>
